"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateToString = exports.Status = exports.LifeCycleState = exports.StatusState = void 0;
var StatusState;

(function (StatusState) {
  StatusState["Unknown"] = "unknown";
  StatusState["Destroyed"] = "destroyed";
  StatusState["Unreachable"] = "unreachable";
  StatusState["PowerOut"] = "powerout";
  StatusState["InTransit"] = "intransit";
  StatusState["TestReady"] = "testready";
  StatusState["PowerUpTest"] = "poweruptest";
  StatusState["FactoryTest"] = "factorytest";
  StatusState["SelfTest"] = "selftest";
  StatusState["InstallReady"] = "installready";
  StatusState["StandBy"] = "standby";
  StatusState["Disabled"] = "disabled";
  StatusState["Dismounted"] = "dismounted";
  StatusState["Preparing"] = "preparing";
  StatusState["WorkOrders"] = "workorders";
  StatusState["Connecting"] = "connecting";
  StatusState["Syncing"] = "syncing";
  StatusState["Events"] = "events";
  StatusState["Storing"] = "storing";
  StatusState["Idle"] = "idle";
  StatusState["Failed"] = "failed";
})(StatusState = exports.StatusState || (exports.StatusState = {}));

var LifeCycleState;

(function (LifeCycleState) {
  LifeCycleState["Manufactured"] = "manufactured";
  LifeCycleState["Installed"] = "installed";
  LifeCycleState["InOperation"] = "inoperation";
  LifeCycleState["Dismounted"] = "dismounted";
  LifeCycleState["Recycled"] = "recycled";
})(LifeCycleState = exports.LifeCycleState || (exports.LifeCycleState = {}));

;

var Status =
/** @class */
function () {
  function Status(state, time) {
    this.state = this.stateFromString(state);
    this.time = new Date(time);
  }
  /** Converts a StatusState into a presentable string */


  Status.prototype.string = function () {
    return stateToString(this.state);
  };
  /** Active devices are devices which Corona is expected to work with. */


  Status.prototype.isActive = function () {
    return this.state === StatusState.Idle || this.state === StatusState.Failed || this.state === StatusState.SelfTest || this.state === StatusState.Preparing || this.state === StatusState.WorkOrders || this.state === StatusState.Connecting || this.state === StatusState.Syncing || this.state === StatusState.Events || this.state === StatusState.Storing || this.state === StatusState.Unreachable || this.state === StatusState.PowerOut;
  };
  /** Passive devices are devices which Corona is not expected get new data or status from.
   *  NOTE: that isPassive != !isActive as PowerOut is present in both sets
  */


  Status.prototype.isPassive = function () {
    return this.state === StatusState.Destroyed || this.state === StatusState.PowerOut || this.state === StatusState.InTransit || this.state === StatusState.TestReady || this.state === StatusState.FactoryTest || this.state === StatusState.PowerUpTest || this.state === StatusState.InstallReady || this.state === StatusState.StandBy || this.state === StatusState.Disabled || this.state === StatusState.Dismounted;
  };
  /** Devices which are in testing are devices which should not produce production data but can possibly communicate */


  Status.prototype.isTesting = function () {
    return this.state === StatusState.FactoryTest || this.state === StatusState.PowerUpTest || this.state === StatusState.SelfTest;
  };
  /* SLADisabled are devices which should be marked for the UI as disabled and does not impact SLA */


  Status.prototype.isSLADisabled = function () {
    return this.state === StatusState.Disabled || this.state === StatusState.InstallReady || this.state === StatusState.Dismounted || this.state === StatusState.Destroyed || this.state === StatusState.InTransit || this.state === StatusState.StandBy;
  };
  /** isCurrentlyWorking returns true if the state in question is one where Corona is currently performing an operation on the device */


  Status.prototype.isCurrentlyWorking = function () {
    return this.state === StatusState.Preparing || this.state === StatusState.WorkOrders || this.state === StatusState.Connecting || this.state === StatusState.Syncing || this.state === StatusState.Events || this.state === StatusState.Storing;
  };

  Status.prototype.stateFromString = function (state) {
    if (state === 'unknown') {
      return StatusState.Unknown;
    }

    if (state === 'destroyed') {
      return StatusState.Destroyed;
    }

    if (state === 'unreachable') {
      return StatusState.Unreachable;
    }

    if (state === 'powerout') {
      return StatusState.PowerOut;
    }

    if (state === 'intransit') {
      return StatusState.InTransit;
    }

    if (state === 'testready') {
      return StatusState.TestReady;
    }

    if (state === 'poweruptest') {
      return StatusState.PowerUpTest;
    }

    if (state === 'factorytest') {
      return StatusState.FactoryTest;
    }

    if (state === 'selftest') {
      return StatusState.SelfTest;
    }

    if (state === 'installready') {
      return StatusState.InstallReady;
    }

    if (state === 'standby') {
      return StatusState.StandBy;
    }

    if (state === 'disabled') {
      return StatusState.Disabled;
    }

    if (state === 'dismounted') {
      return StatusState.Dismounted;
    }

    if (state === 'preparing') {
      return StatusState.Preparing;
    }

    if (state === 'workorders') {
      return StatusState.WorkOrders;
    }

    if (state === 'connecting') {
      return StatusState.Connecting;
    }

    if (state === 'syncing') {
      return StatusState.Syncing;
    }

    if (state === 'events') {
      return StatusState.Events;
    }

    if (state === 'storing') {
      return StatusState.Storing;
    }

    if (state === 'idle') {
      return StatusState.Idle;
    }

    if (state === 'failed') {
      return StatusState.Failed;
    }

    if (state === 'manufactured') {
      return LifeCycleState.Manufactured;
    }

    if (state === 'installed') {
      return LifeCycleState.Installed;
    }

    if (state === 'inoperation') {
      return LifeCycleState.InOperation;
    }

    if (state === 'recycled') {
      return LifeCycleState.Recycled;
    }

    return StatusState.Unknown;
  };

  return Status;
}();

exports.Status = Status;
/** Converts a StatusState into a presentable string.
 * NOTE: If you are operating on a Status object then use the .string() function on it.
 *
 *  - `state` - A string with the API formatted state enum value
 *
 * Returns: A user friendly formatted value
 */

function stateToString(state) {
  var output = "Unknown";

  switch (state) {
    case StatusState.Destroyed:
      output = "Recycled";
      break;

    case StatusState.Unreachable:
      output = "Unreachable";
      break;

    case StatusState.PowerOut:
      output = "Power out";
      break;

    case StatusState.InTransit:
      output = "In transit";
      break;

    case StatusState.TestReady:
      output = "Test ready";
      break;

    case StatusState.PowerUpTest:
      output = "Power up test";
      break;

    case StatusState.FactoryTest:
      output = "Factory test";
      break;

    case StatusState.SelfTest:
      output = "Performing self test";
      break;

    case StatusState.InstallReady:
      output = "Installation ready";
      break;

    case StatusState.StandBy:
      output = "Stand by";
      break;

    case StatusState.Disabled:
      output = "Disabled";
      break;

    case StatusState.Dismounted:
      output = "Dismounted";
      break;

    case StatusState.Preparing:
      output = "Preparing";
      break;

    case StatusState.WorkOrders:
      output = "Performing work orders";
      break;

    case StatusState.Connecting:
      output = "Connecting";
      break;

    case StatusState.Syncing:
      output = "Synchronizing info";
      break;

    case StatusState.Events:
      output = "Downloading logs";
      break;

    case StatusState.Storing:
      output = "Storing data";
      break;

    case StatusState.Idle:
      output = "Ready";
      break;

    case StatusState.Failed:
      output = "Failed to connect";
      break;

    case StatusState.Unknown:
      output = "Unknown";
      break;

    case LifeCycleState.Manufactured:
      output = "Manufactured";
      break;

    case LifeCycleState.Installed:
      output = "Installed";
      break;

    case LifeCycleState.InOperation:
      output = "In Operation";
      break;

    case LifeCycleState.Dismounted:
      output = "Dismounted";
      break;

    case LifeCycleState.Recycled:
      output = "Recycled";
      break;

    default:
      output = "Unknown";
      break;
  }

  return output;
}

exports.stateToString = stateToString;
exports.default = Status;